import { Reducer } from 'redux';

import { SupervisorsTypes, SupervisorsState } from './types';

const INITIAL_STATE: SupervisorsState = {
  supervisorsList: [],
};

const reducer: Reducer<SupervisorsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES SUPERVISORS LIST
    case SupervisorsTypes.SET_SUPERVISORS_LIST:
      return {
        ...state,
        supervisorsList: action.payload.supervisorsList,
      };

    default:
      return state;
  }
};

export default reducer;
